import { ReactNode, Children } from 'react';

import { Box } from '@mui/material';
import { PanelTitle } from '@apigrowfinance/pbolt-panel';

import DividingLine from '@components/overviewPanels/statementPanel/DividingLine';

interface DividerPanelProps {
    children: ReactNode;
    title?: ReactNode;
    isClickable?: boolean;
    isLoading?: boolean;
    isHovered?: boolean;
}

const DividerPanel = ({
    children,
    isClickable = true,
    isLoading = false,
    isHovered = false,
    title,
}: DividerPanelProps) => {
    const arrayChildren = Children.toArray(children);
    const showTopBar = !!title || isClickable;
    return (
        <>
            {showTopBar && (
                <PanelTitle
                    loading={isLoading}
                    hovered={isHovered}
                    hideArrows={!isClickable}>
                    {title}
                </PanelTitle>
            )}

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                    alignItems: 'center',
                    flexGrow: 1,
                }}>
                {Children.map(arrayChildren, (child, i) => {
                    return (
                        <Box
                            key={`panel-item-${i}`}
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                flexGrow: 1,
                            }}>
                            {child}
                            {!(arrayChildren.length - 1 === i) && (
                                <DividingLine />
                            )}
                        </Box>
                    );
                })}
            </Box>
        </>
    );
};

export default DividerPanel;
